import { useState } from "react";
import { ChevronDownIcon } from "lucide-react";

const filterOptions = {
  "Content Type": ["Image", "Video", "Article"],
  Style: ["Casual", "Formal", "Traditional"],
  Color: ["Red", "Blue", "Green", "Black"],
  Season: ["Summer", "Winter", "Spring", "Autumn"],
  Occasion: ["Party", "Wedding", "Casual Outing"],
  Gender: ["Male", "Female", "Unisex"],
  Creator: ["Photographer", "Designer", "Influencer"],
};

export default function FilterBar() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({});

  const handleSelect = (filter, option) => {
    setSelectedOptions((prev) => ({ ...prev, [filter]: option }));
    setOpenDropdown(null);
  };

  return (
    <div className="flex flex-wrap justify-between items-center gap-4 mb-6">
      {/* Filter Buttons */}
      <div className="flex flex-wrap gap-2">
        {Object.keys(filterOptions).map((filter, index) => (
          <div key={index} className="relative">
            <button
              onClick={() =>
                setOpenDropdown(openDropdown === index ? null : index)
              }
              className="flex items-center gap-1 bg-white text-black px-4 py-1 rounded-full shadow-md"
            >
              <span>{selectedOptions[filter] || filter}</span>
              <ChevronDownIcon size="1em"
                className={`transition-transform duration-200 ${
                  openDropdown === index ? "rotate-180" : ""
                }`}
              />
            </button>

            {openDropdown === index && (
              <div className="absolute top-full left-0 mt-1 bg-white text-black rounded shadow-md z-10 w-40">
                {filterOptions[filter].map((option, i) => (
                  <div
                    key={i}
                    onClick={() => handleSelect(filter, option)}
                    className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Search  */}
      <div className="relative">
        <input
          type="text"
          placeholder="Search..."
          className="px-4 py-1 text-black border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
        />
      </div>
    </div>
  );
}
